import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.main');
import { OnInit, Input } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-kiosk-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.main/view.scss */
/* src/app/portal.kiosk.main/view.scss: no such file or directory */`],
})
export class PortalKioskMainComponent implements OnInit {
    @Input() event: any;

    public isvisible: boolean = false;

    public mode: any = 'integration';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public async start(lang: string) {
        await this.event.lang(lang);
        await this.event.view('camera');
        await this.event.set('mode', this.mode);
    }

    public async clickVisible() {
        this.isvisible = !this.isvisible;
        await this.service.render();
    }

}

export default PortalKioskMainComponent;